import React from "react";
import Toast, { Position } from "devextreme-react/toast";

export default function Snackbar({ message, onHiding, of, options }) {
	return (
		<Toast
			displayTime={4000}
			message={message}
			onHiding={onHiding}
			type={options.type}
			visible={options.visible}
			width={128}
		>
			<Position offset="0 320" of={of} />
		</Toast>
	);
}
